import { render, staticRenderFns } from "./PFIQuickLinksWidget.vue?vue&type=template&id=38db5b98&scoped=true&"
import script from "./PFIQuickLinksWidget.vue?vue&type=script&lang=js&"
export * from "./PFIQuickLinksWidget.vue?vue&type=script&lang=js&"
import style0 from "./PFIQuickLinksWidget.vue?vue&type=style&index=0&id=38db5b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db5b98",
  null
  
)

export default component.exports